import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const notificationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getNotificationTotal: builder.query({
			query: (args) => ({
				url: `${process.env.NEXT_PUBLIC_NOTIFICATION_V3}/notification/counter`,
				headers: {
					...env.HEADERS,
					Authorization: args?.token,
				},
			}),
		}),
	}),
});

export const { useGetNotificationTotalQuery } = notificationApiSlice;
